import { TOOL_NAMES } from 'js/src/agent/toolNames';

/**
 * Returned by the review tools when the user bails out of the review phase.
 *
 * Worded as an instruction rather than an error on purpose: the call succeeded, and the
 * model needs to know not to retry or switch to the other review tool.
 *
 * A function rather than a constant because the tools returning it import this module:
 * naming them at call time keeps the two out of a module-initialisation cycle, which as
 * a top-level constant would read one of the classes before it was defined.
 */
export const reviewSkippedResult = (): string =>
    'Skipped: the user asked to stop reviewing and use the video as-is. ' +
    "Don't call any more review tools this turn " +
    `(${TOOL_NAMES.reviewSceneImages}, ${TOOL_NAMES.imageAsk}, or ${TOOL_NAMES.lintVideo}).`;
